import _ from "lodash-es";
import {
  getNestedConnectedOrders,
  groupByProcessPosition,
  sortObjectProperties
} from "@components/module-components/POSMap/helper";

export const formatDataMap = (dataMap: any[]) => {
  try {

    if (dataMap.length >= 1) {

      let ordersList: any[] = [];
      let orderedProcesses: any[] = []

      for (let item of dataMap) {
        let connected_orders = _.cloneDeep(item?.connected_orders)
        orderedProcesses = [...orderedProcesses, ...getNestedConnectedOrders(connected_orders), item]

        if (_.size(orderedProcesses) > 0) {
          ordersList = [...orderedProcesses]
        }
      }

      let ts: any = []
      _.forEach(ordersList, (process, index) => {
        let t: any = {};
        process.custom_order = index + 1 + ""
        process.longitude = process.process_long;
        process.latitude = process.process_lat
        process.id = `${process.latitude}-${process.longitude}`
        t.process_position_b2c = process.process_position_b2c
        t.id = `${process.latitude}-${process.longitude}`
        process = sortObjectProperties(process)
        ts.push(t)
        return process;
      })

      ordersList = [...ordersList].map((order) => {
        order.id = `${order.process_lat}-${order.process_long}`
        return order;
      })

      let t = [...ordersList.reduce((prev: any[], curVal: any) => {
        const isExist = prev.findIndex((location: any) => location.id === `${curVal.process_lat}-${curVal.process_long}`);
        if (isExist !== -1) {
          prev[isExist] = {
            ...prev[isExist],
            process_position_b2c: curVal.process_position_b2c,
            name: curVal.name,
            list: prev[isExist].list.concat(curVal)
          }
        } else {
          const newLocation = {
            ...curVal,
            list: [curVal]
          }
          prev.push(newLocation);
        }
        return prev;
      }, [] as any[])];

      return ordersList
    }

  } catch (e) {
    console.error(e)
  }
}